// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__zpqg_","scroll-target":"styles_scroll-target__zrfOm","description":"styles_description__35Dzt","bio-content":"styles_bio-content__jubkW"};